import CheckMarkNurturePurple from "../../assets/images/general_icons/check_mark_nurture_purple.svg";
import React from "react";
var FeedbackPublishedText = function FeedbackPublishedText() {
  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement("img", {
    width: 25,
    src: CheckMarkNurturePurple
  }), /*#__PURE__*/React.createElement("div", {
    className: "ms-1 text-nurture-purple font-size-20"
  }, "Feedback has been published.")), /*#__PURE__*/React.createElement("hr", {
    className: "light-divider"
  }));
};
export default FeedbackPublishedText;